import React from 'react';
import { Trash2 } from 'lucide-react';

const HotTakesItemBlock = ({ block, onUpdate, onDelete }) => {
  return (
    <div className="block-item hottakes-block">
      <div className="block-header">
        <span>Hot Take</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <textarea
        placeholder="Your hot take here..."
        value={block.content || ''}
        onChange={(e) => onUpdate(block.id, { content: e.target.value })}
        className="field-textarea"
      />
      <select
        value={block.heat || 'Medium'}
        onChange={(e) => onUpdate(block.id, { heat: e.target.value })}
        className="field-select"
      >
        <option value="Lukewarm">Lukewarm</option>
        <option value="Medium">Medium</option>
        <option value="Spicy">Spicy</option>
        <option value="Volcanic">Volcanic</option>
      </select>
    </div>
  );
};

export default HotTakesItemBlock;
